import styled from 'styled-components';

import { rem } from 'approot/shared/style';
import { grey1 } from 'approot/shared/styles/colours.style';
import { spacing24 } from 'approot/shared/styles/spacing.style';
import { ACTIVITY_BUILDER_A4_LONG_SIDE } from '../activity-builder.constants';
import { ActivityBuilderSlideContent } from '../activity-builder-slide.style';

export const PagePreviewSlide = styled.div`
  inset: 0;
  position: absolute;
`;

type PagePreviewWrapperProps = {
  $isLoading?: boolean;
  $height: number;
};
export const PagePreviewWrapper = styled.div<PagePreviewWrapperProps>`
  background-color: ${grey1};
  transition: opacity 200ms ease;
  opacity: ${({ $isLoading }) => ($isLoading ? 0 : 1)};
  padding-top: ${({ $height }) =>
    ($height / ACTIVITY_BUILDER_A4_LONG_SIDE) * 100}%;
`;

type PagePreviewProps = {
  $bgUrl?: string | null;
  $height: number;
};
export const PagePreview = styled.div<PagePreviewProps>`
  inset: 0;
  position: absolute;
  width: ${rem(ACTIVITY_BUILDER_A4_LONG_SIDE)};
  height: ${({ $height }) => rem($height)};

  ${PagePreviewSlide} {
    ${({ $bgUrl }) =>
      $bgUrl &&
      `
      background-image: url(${$bgUrl});
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center;
    `}
  }
`;

type PagePreviewSlideContentProps = {
  $height: number;
};
export const PagePreviewSlideContent = styled(
  ActivityBuilderSlideContent
)<PagePreviewSlideContentProps>`
  height: ${({ $height }) => rem($height)};
  padding: ${rem(spacing24)};
`;
